



























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { InputInterface } from '../types/Exa_Input'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { getFileNameFromHeader, base64ToArrayBuffer } from '@/utils/helpers'

@Component({
    components: {
        FontAwesomeIcon
    }
})
export default class InputFile extends Vue {
    @Prop() private libelle!: string
    @Prop() private description!: string
    @Prop() private value!: any
    @Prop() private ident!: any
    @Prop() private requis!: boolean
    @Prop({ default: { min: 1, max: 1 } }) private data!: { min: any; max: any }
    @Prop() private disabled!: boolean
    @Prop() mode_lecture!: boolean
    @Prop() condition!: InputInterface
    @Prop() storeDocument!: Function | null
    @Prop() getDocument!: Function | null
    @Prop() deleteDocument!: Function | null
    @Prop({ default: false }) check_validation!: boolean
    @Prop({ default: false }) visionneuse_enabled!: boolean

    documentToDelete: any = null
    showModalMessageDeleteDocument = false
    showModalMessageDocumentTropLourd = false
    showModalMessageDocumentErreur = false

    /** 
     * buildDocuments 
     * Construit les documents en écoutant les modifications de la valeur avec l'option immediate activée. 
     * @param {None} - Aucun paramètre requis. 
     */
    @Watch('value', { immediate: true, deep:true }) 
    buildDocuments () {
        if (this.value !== null && this.value !== undefined && Array.isArray(this.value)) {
            this.documents = this.value
        }
    }

    /** 
     * closeModalDocTropLourd 
     * Ferme la modal affichant le message de document trop lourd. 
     * @param {None} - Aucun paramètre requis. 
     */
    closeModalDocTropLourd() {
        this.showModalMessageDocumentTropLourd = false
    }

    closeModalDocErreur () {
        this.showModalMessageDocumentErreur = false
        this.errorDoc = null
    }

    documents: Array<any> = []
    errorDoc: any = null
    /** 
     * selectFile 
     * Gère la sélection d'un fichier en vérifiant sa taille et en effectuant les actions appropriées. 
     * @param {Event} e - L'événement de sélection de fichier. 
     */
    selectFile (e: Event) {
        this.errorDoc = null
        if (e.target !== null) {
            const target = e.target as HTMLInputElement
            const file: File = (target.files as FileList)[0]
            const maxAllowedSize = 5 * 1024 * 1024
            if (file.size > maxAllowedSize) {
                (e.target as HTMLInputElement).files = null
                const inputFile: any = e.target
                inputFile.value = null
                this.showModalMessageDocumentTropLourd = true
            } else {
                if (this.storeDocument) {
                    this.storeDocument(file.name, file).then((response: any) => {
                        this.documents.push({ titre: file.name, id: response.id })
                        this.$emit('input', { ident: this.ident, value: this.documents })
                    }).catch((error: any) => {
                        this.errorDoc = error
                        this.showModalMessageDocumentErreur = true
                        console.log('error : ' + error)
                    })
                } else {
                    const reader = new FileReader()

                    reader.addEventListener('load', () => {
                        const objTemp: any = { titre: file.name, data: reader.result, id: null }
                        this.documents.push(objTemp)
                        this.$emit('input', { ident: this.ident, value: this.documents })
                    }, false)
    
                    reader.readAsDataURL(file)
                }
            }
        }
    }
    
    /** 
     * deleteDocumentHandler 
     * Gère la suppression d'un document en affichant une modal de confirmation. 
     * @param {any} doc - Le document à supprimer. 
     */
    deleteDocumentHandler (doc: any) {
        this.documentToDelete = doc
        this.showModalMessageDeleteDocument = true
    }

    /** 
     * deleteDocumentSuite 
     * Gère la suite de la suppression d'un document en appelant la fonction de suppression appropriée. 
     * @param {None} - Aucun paramètre requis. 
     */
    deleteDocumentSuite () {
        if (this.deleteDocument) {
            this.deleteDocument(this.documentToDelete.id).then(() => {
                this.deleteDocumentFin()
            })
        } else {
            this.deleteDocumentFin()
        }
    }
    
    /** 
     * deleteDocumentFin 
     * Gère la suppression finale d'un document en mettant à jour la liste des documents et en émettant un événement d'entrée avec les données mises à jour. 
     * @param {None} - Aucun paramètre requis. 
     */
    deleteDocumentFin () {
        const documentsTemp = []
        for (let i = 0; i < this.documents.length; i++) {
            if ((this.documents[i].id && this.documents[i].id !== this.documentToDelete.id) || (this.documents[i].data && this.documents[i].data !== this.documentToDelete.data)) {
                documentsTemp.push(this.documents[i])
            }
        }
        this.documents = documentsTemp
        this.$emit('input', { ident: this.ident, value: this.documents })
        this.documentToDelete  = null
        this.showModalMessageDeleteDocument = false
    }

    /** 
     * cancelDeleteDocument 
     * Annule la suppression du document en réinitialisant les valeurs appropriées. 
     * @param {None} - Aucun paramètre requis. 
     */
    cancelDeleteDocument () {
        this.documentToDelete = null
        this.showModalMessageDeleteDocument = false
    }

    /** 
     * download 
     * Télécharge le document spécifié. 
     * @param {any} doc - Le document à télécharger. 
     */
    download(doc: any, docKey: any) {
        if (this.mode_lecture && this.visionneuse_enabled) {
            this.$emit('showVisionneuse', { input_id: this.ident, fileKey: docKey })
        } else {
            if (doc.data) {
                const url = doc.data
                const link = document.createElement('a')
                link.href = url
                link.setAttribute(
                    'Download',
                    doc.titre
                )
                document.body.appendChild(link)
                link.click()
            } else {
                if (this.getDocument) {
                    this.getDocument(doc.id).then((response: any) => {
                        let fileName = ''
                        const fileNameTemp = getFileNameFromHeader(response.headers) || doc.titre
                        if (fileNameTemp) {
                            fileName = fileNameTemp
                        }
                        const url = response.data
                        // const url = URL.createObjectURL(new Blob([base64ToArrayBuffer(response.data)]))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute(
                            'Download',
                            fileName
                        )
                        document.body.appendChild(link)
                        link.click()
                    })
                }
            }
        }
    }

    /** 
     * mount 
     * Initialise la fonction buildDocuments lors du montage du composant. 
     * @param {None} - Aucun paramètre requis. 
     */
    mount() {
        this.buildDocuments()
    }
}

